module.exports = __webpack_public_path__ + "static/media/login_background.5cb24f6d.png";